"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClinicalKeywords = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("@xstate/react");
const ProviderTabs_styles_1 = require("../../ProviderTabs.styles");
const ClinicalKeywordsTable_1 = require("./ClinicalKeywordsTable");
const types_1 = require("../../../types");
const state_1 = require("./state");
const NOOP = () => {
    // no operation
};
const ClinicalKeywords = ({ labels: { tableHeaderLabel = 'Clinical Keywords', nextPageLabel = 'Next', previousPageLabel = 'Previous', noRecordsLabel = 'This provider does not have any clinical keyword records on file.', noRecordsOnSearchLabel = 'No clinical keyword records could be found that match your search criteria. Please remove your search term and try again.' } = {}, provider, customerCode, productName, onFetchSuccess = NOOP, onFetchError = NOOP, version = types_1.SEARCH_API_VERSION.V9, stateEventHandlers }) => {
    const machine = (0, react_1.useMemo)(() => (0, state_1.createClinicalKeywordsMachine)({
        provider,
        customerCode,
        productName,
        version
    }), []);
    const [state] = (0, react_2.useMachine)(machine, {
        devTools: true,
        actions: { onFetchSuccess, onFetchError }
    });
    const isLoading = state.matches(state_1.ClinicalKeywordsStates.LOADING_CLINICAL_KEYWORDS);
    return (react_1.default.createElement(ProviderTabs_styles_1.Content, { "data-testid": "clinical_keywords" },
        react_1.default.createElement(ClinicalKeywordsTable_1.ClinicalKeywordsTable, { id: `${provider.id}-clinical-keywords`, labels: {
                tableHeaderLabel,
                nextPageLabel,
                previousPageLabel,
                noRecordsLabel,
                noRecordsOnSearchLabel
            }, clinicalKeywords: state.context.clinicalKeywords, isLoading: isLoading, stateEventHandlers: stateEventHandlers })));
};
exports.ClinicalKeywords = ClinicalKeywords;
//# sourceMappingURL=ClinicalKeywords.js.map